import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import { HiHome } from "react-icons/hi";
import styles from "./styles.module.sass";
import {
  Container,
  FormControl,
  InputGroup,
  Nav,
  Navbar,
} from "react-bootstrap";
import { setAgentFilter } from "../../state/actions/agentActions";
import { ALLOWED_ROLES, INCOMPLETE_FILTERS } from "../../constants/filters";
import { logout, userProfile } from "../../state/actions/accountActions";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import cn from "classnames";
import { useCodeSearchContext } from "../../context/CodeSearchProvider";
import { FaSearch } from "react-icons/fa";
import { translate, mapCategoriesToOptions } from "../../utils";

export const AgentHeader = () => (
  <div className={styles.header}>
    <h1 style={{ color: "white" }}>Agent Panel</h1>
  </div>
);

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const filters = useSelector((state) => state.staticValues.filters) || {};
  const translations =
    useSelector((state) => state.staticValues.translations) || {};
  const lang = useSelector((state) => state.staticValues.lang);
  const currentUser = useSelector((state) => state.account.user);
  const tasksTotalCount = useSelector(
    (state) => state.property.tasksTotalCount
  );
  const isUploadingImages = useSelector(
    (state) => state.property.isUploadingImages
  );

  const t = (key) => translate(translations, lang, key);

  const mainCategories = (Array.isArray(filters) ? filters : []).filter(
    (item) => item.is_main_category
  );

  const filt = mapCategoriesToOptions(mainCategories, translations, lang);
  const handleCodeSearchRef = useCodeSearchContext();
  const [selectedCode, toggleCode] = useState("");
  const [expanded, setExpanded] = useState(false);

  const checkIfAgentIsLoggedIn = () => {
    dispatch(userProfile()).then((res) => {
      if (!ALLOWED_ROLES.includes(res?.role)) {
        navigate("/login");
      }
    });
  };

  const handleCodeSearchHeader = (isHome = false) => {
    checkIfAgentIsLoggedIn();
    isHome
      ? handleCodeSearchRef.current?.handleCodeSearch("")
      : handleCodeSearchRef.current?.handleCodeSearch(selectedCode);
  };

  const handleCodeChange = (e) => {
    toggleCode(e.target.value);
  };

  return (
    <div>
      <Form
        key={`form-search`}
        className={styles.searchButtonContainer}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
            handleCodeSearchHeader();
          }
        }}
      >
        <InputGroup
          key={`form-search-input-group`}
          className={cn(
            styles.searchInputHolder,
            "justify-content-end container"
          )}
        >
          <FormControl
            key={`form-control-search`}
            className={cn(styles.searchInput, "text-white")}
            placeholder="Pretraga po šifri"
            aria-label="Pretraga po šifri"
            type={"number"}
            aria-describedby="basic-addon2"
            onChange={handleCodeChange}
            value={selectedCode}
          />
          <FaSearch
            key={`form-search-icon`}
            onClick={() => handleCodeSearchHeader()}
            color={"white"}
            size={"1.1rem"}
          />
        </InputGroup>
      </Form>
      <Navbar
        key={`header-navbar`}
        bg="light"
        variant="light"
        expand="lg"
        expanded={expanded}
        onToggle={(expanded) => setExpanded(expanded)}
        className={styles.navbarCustom}
      >
        <Container
          key={`header-container`}
          className="d-flex justify-content-end"
        >
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            style={{ width: "55px" }}
            onClick={() => setExpanded(!expanded)}
          />
          <Navbar.Collapse
            id="responsive-navbar-nav"
            style={{ width: "100%", justifyContent: "space-between" }}
          >
            <Link
              key={`header-nav-home-link`}
              to="/home"
              className={styles.home}
              onClick={() => {
                toggleCode("");
                handleCodeSearchHeader(true);
                setExpanded(false);
              }}
            >
              <HiHome />
              Home
            </Link>
            <div className={styles.headerAdmin}>
              <Nav style={{ display: "flex", gap: "10px", width: "100%" }}>
                <button
                  key={`header-nav-button`}
                  className={styles.button3}
                  onClick={() => {
                    navigate("/properties/add");
                    setExpanded(false);
                  }}
                >
                  {t("add_property_menu")}
                </button>
                <div className={styles.dropdownWrapper}>
                  <DropdownButton
                    key={`header-navbar-dropdown-button-0`}
                    id="dropdown-basic-button"
                    title={t("top_search_property_type")}
                    className={styles.button2}
                    drop="down-centered"
                  >
                    <Dropdown.Item
                      key={`header-navbar-dropdown-item-0`}
                      id={`basic-type-0`}
                      className={styles.item}
                      onClick={() => {
                        navigate(`/home/all`);
                        setExpanded(false);
                      }}
                    >
                      Svi
                    </Dropdown.Item>
                    {filt.map((filt, index) => (
                      <Dropdown.Item
                        key={`header-navbar-dropdown-item-type-${index}`}
                        id={`basic-type-${index}`}
                        className={styles.item}
                        onClick={() => {
                          dispatch(setAgentFilter(filt.id));
                          navigate(`/home/${filt.id}`);
                          setExpanded(false);
                        }}
                      >
                        {filt.value}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                </div>
                <div className={styles.dropdownWrapper}>
                  <DropdownButton
                    key={`header-navbar-dropdown-button-1`}
                    id="dropdown-basic-button"
                    title="Nepotpune"
                    className={styles.button2}
                    drop="down-centered"
                  >
                    {INCOMPLETE_FILTERS.map((filter, index) => (
                      <Dropdown.Item
                        key={`header-navbar-dropdown-item-filt-${index}`}
                        id={`filt-value-${index}`}
                        className={styles.item}
                        onClick={() => {
                          dispatch(setAgentFilter(filter.value));
                          navigate(`/home/${filter.value}`);
                          setExpanded(false);
                        }}
                      >
                        {filter.name}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                </div>
                {(currentUser?.role === "menadzer" ||
                  currentUser?.role === "rukovodilac") && (
                  <button
                    key={`header-navbar-button-recommendation`}
                    className={styles.button4}
                    onClick={() => {
                      navigate(`/recommendations/${currentUser?.id}`);
                      setExpanded(false);
                    }}
                  >
                    Preporuke
                  </button>
                )}
                <button
                  key={`header-navbar-button-add-user-messages`}
                  className={styles.button4}
                  onClick={() => {
                    navigate("/properties/add");
                  }}
                >
                  Poruke Korisnika
                  <div className={styles.absoluteCircle}>0</div>
                </button>
                <button
                  key={`header-navbar-button-admin-messages`}
                  className={styles.button4}
                  onClick={() => {
                    navigate("/properties/add");
                  }}
                >
                  Poruke Admina
                  <div className={styles.absoluteCircle}>{tasksTotalCount}</div>
                </button>
                <button
                  key={`header-navbar-button-logout`}
                  className={styles.button}
                  disabled={isUploadingImages}
                  title={
                    isUploadingImages
                      ? "Slike se još uvek uploaduju ili obrađuju. Sačekajte da se završi."
                      : undefined
                  }
                  onClick={() => {
                    if (isUploadingImages) {
                      window.alert(
                        "Slike se još uvek uploaduju ili obrađuju. Sačekajte da se završi pre odjave."
                      );
                      return;
                    }
                    dispatch(logout()).then(() => navigate("/login"));
                    setExpanded(false);
                  }}
                >
                  {t("top_menu_logout")}
                </button>
              </Nav>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
